import { api, apiCall, apiActionDispatcher, signalRWrappedApiCall } from './api';
import {
  addScenarioCommentActionTypes,
  fetchAnnotationsActionTypes,
  removeAnnotationsActionTypes
} from './types';
import { annotation as constants } from './../helpers';
import { getAnnotationsByType } from './../reducers';
import {
  subscriptionTypes,
  signalRHubManager
} from './signalRHub/signalRHubManager';

const fetchAnnotationsDispatcher =
  apiActionDispatcher({ actionTypes: fetchAnnotationsActionTypes });
const fetchAnnotations = (
  apiFunc,
  hasBeenLoaded,
  isFinalFetch,
  additionalArgs
) => signalRWrappedApiCall(
  apiCall(
    fetchAnnotationsDispatcher,
    apiFunc,
    hasBeenLoaded,
    isFinalFetch,
    state => state.annotations.request,
    null,
    additionalArgs
  ),
  fetchAnnotationsDispatcher,
  signalRHubManager,
  subscriptionTypes.annotations
);

export const fetchScenariosAnnotations = () => fetchAnnotations(
  api.annotations.fetchScenariosAnnotations,
  state => {
    const byType = getAnnotationsByType(state)[constants.SCENARIO_TYPED];
    return byType && byType.length > 0;
  },
  isDone => {
    if (isDone) {
      if (!isDone.includes(constants.SCENARIO_TYPED)) {
        return [...isDone, constants.SCENARIO_TYPED];
      }
      return isDone;
    }
    return [constants.SCENARIO_TYPED];
  }
);

export const fetchBuildAnnotations = () => fetchAnnotations(
  api.annotations.fetchBuildAnnotations,
  state => {
    const byType = getAnnotationsByType(state)[constants.BUILD_TYPED];
    return byType && byType.length > 0;
  },
  isDone => {
    if (isDone) {
      if (!isDone.includes(constants.BUILD_TYPED)) {
        return isDone.push(constants.BUILD_TYPED);
      }
      return isDone;
    }
    return [constants.BUILD_TYPED];
  }
);

export const fetchAppAnnotations = (days) => fetchAnnotations(
  api.annotations.fetchAppAnnotations,
  state => {
    const byType = getAnnotationsByType(state)[constants.APP_TYPED];
    return byType && byType.length > 0;
  },
  isDone => {
    if (isDone) {
      if (!isDone.includes(constants.APP_TYPED)) {
        return isDone.push(constants.APP_TYPED);
      }
      return isDone;
    }
    return [constants.APP_TYPED];
  },
  [days]
);

const addItemCommentDispatcher =
 apiActionDispatcher({
   actionTypes: addScenarioCommentActionTypes,
   responseHandler: response => ({ [response.id]: response }),
   useResponseErrorMessage: true
 });

const addComment = (apiFunc, item, annotation = {}) => {
  if (annotation.user !== null) {
    localStorage.setItem('userName', annotation.user);
  }
  return apiCall(
    addItemCommentDispatcher,
    apiFunc,
    null,
    null,
    null,
    [item.id, annotation],
    null
  );
};

export const addScenarioComment = (scenario, annotation) =>
  addComment(api.annotations.addScenarioComment, scenario, annotation);

export const addBuildComment = (build, annotation) =>
  addComment(api.annotations.addBuildComment, build, annotation);

export const addAppComment = (app, annotation) =>
  addComment(api.annotations.addAppComment, app, annotation);

const removeAnnotationsDispatcher =
apiActionDispatcher({
  actionTypes: removeAnnotationsActionTypes,
  responseHandler: null,
  useResponseErrorMessage: true
});
const removeComment = (apiFunc, annotationId) => apiCall(
  removeAnnotationsDispatcher,
  apiFunc,
  null,
  null,
  null,
  null,
  [annotationId],
  null,
  null
);

export const removeScenarioComment = (annotationId) =>
  removeComment(api.annotations.removeScenarioComment, annotationId);

export const removeBuildComment = (annotationId) =>
  removeComment(api.annotations.removeBuildComment, annotationId);

export const removeAppComment = (annotationId) =>
  removeComment(api.annotations.removeAppComment, annotationId);


// WEBPACK FOOTER //
// src/actions/annotations.js